import type { Content, TableLayout } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { cm, pdfColors, tableLayouts } from '../../theme.pdf';
import { BLOCK_SPACING } from '../layout';

type KvBlock = Extract<ViewBlock, { type: 'kv' }>;

type LayoutKey = keyof typeof tableLayouts;

const LABEL_COL_WIDTH_CM = 4.6;

export function renderKvBlock(
  block: KvBlock,
  options: { layout?: LayoutKey; marginBottom?: number } = {}
): Content {
  const layoutKey = options.layout ?? 'default';
  const marginBottom = options.marginBottom ?? BLOCK_SPACING;

  return {
    table: {
      widths: [cm(LABEL_COL_WIDTH_CM), '*'],
      dontBreakRows: true,
      body: block.items.map((item) => [
        {
          text: item.label,
          style: 'tableCellLabel',
          fillColor: item.highlight ? pdfColors.yellow : undefined,
        },
        {
          text: item.value ?? '—',
          style: 'tableCell',
          fillColor: item.highlight ? pdfColors.yellow : undefined,
        },
      ]),
    },
    layout: tableLayouts[layoutKey] as TableLayout,
    margin: [0, 0, 0, marginBottom],
  };
}
